import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/router";
import { shouldRel } from "./utils";
import { SocialIcons } from "../social-icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Top = () => {
  var _router$query$slug;

  var router = useRouter();
  var slug = ((_router$query$slug = router.query.slug) == null ? void 0 : _router$query$slug.toString()) || "/";
  return /*#__PURE__*/_jsx("div", {
    className: "hidden sm:block bg-tertiary",
    children: /*#__PURE__*/_jsxs("div", {
      className: "hidden sm:flex gap-2 justify-end px-4 py-2 text-sm text-tertiary max-w-7xl w-full mx-auto",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex gap-4 justify-end",
        children: top.map((_ref, i) => {
          var {
            label,
            href
          } = _ref;
          return /*#__PURE__*/_jsx(Link, {
            href: href,
            children: /*#__PURE__*/_jsx("a", {
              rel: shouldRel(href),
              className: clsx("hover:underline pointer-cursor", {
                "text-primary underline": slug === href
              }),
              children: label
            })
          }, i);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-[1px] bg-white/50"
      }), /*#__PURE__*/_jsx(SocialIcons, {})]
    })
  });
};
var top = [{
  label: "Retail",
  href: "https://www.cancercouncilshop.org.au/"
}, {
  label: "About us",
  href: "/about-us"
}, {
  label: "News & Media",
  href: "/news"
}, {
  label: "Blog",
  href: "/blog"
}, {
  label: "Local services",
  href: "/local-services"
}, {
  label: "Careers",
  href: "/careers"
}, {
  label: "Contact us",
  href: "/contact-us"
}];
//# sourceMappingURL=top.js.map